var _defs, _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _path6, _path7, _path8, _path9, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _path10, _g17, _path11, _g18, _path12, _g19, _path13, _g20, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrositesPhase5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.63 612.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .microsites-disable-phase5{\n        fill: #edeef0 !important; \n      }\n      .microsites-disable-phase5:hover {\n        pointer-events: none;\n        fill: #edeef0 !important; \n      }\n\n      .microsites-phase5-1, .microsites-phase5-2, .microsites-phase5-3 {\n        stroke-width: 0px;\n      }\n\n      .microsites-phase5-1, .microsites-phase5-4, .microsites-phase5-5 {\n        fill: #e87203;\n      }\n\n      .microsites-phase5-6 {\n        fill: #fff;\n      }\n\n      .microsites-phase5-6, .microsites-phase5-4, .microsites-phase5-7, .microsites-phase5-5 {\n        stroke: #e87203;\n      }\n\n      .microsites-phase5-2 {\n        fill: #333;\n      }\n\n      .microsites-phase5-7, .microsites-phase5-8 {\n        fill: none;\n      }\n\n      .microsites-phase5-8, .microsites-phase5-9, .microsites-phase5-10 {\n        stroke: #f77700;\n      }\n\n      .microsites-phase5-9, .microsites-phase5-5 {\n        stroke-width: .05px;\n      }\n\n      .microsites-phase5-9, .microsites-phase5-10 {\n        fill: #f77700;\n      }\n\n      .microsites-phase5-3 {\n        fill: #3a414a;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-5",
    d: "M173.1,153.09h-1v-12.84h1v12.84ZM173.1,118.92h-1v-18.75h1v18.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-1",
    d: "M173.1,100.17h-1v-.5h1v.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-5",
    d: "M173.12,100.21h-1.05v-.56h1.05v.56ZM172.12,99.71v.45h.95v-.47l-.95.02Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-1",
    d: "M172.6,167.87l-4.64-14.28h9.28l-4.64,14.28Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-5",
    d: "M172.6,169.47l-5.33-16.38h10.65l-5.32,16.38ZM168.65,154.09l3.95,12.15,3.95-12.15h-7.9Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Q",
    className: "microsites-phase5-2",
    d: "M70.38,124.15c-.05-2.12-4.64-2.27-4.79-.15.89,3.26,7.46.49,7.6,5.63.15,4.69-8.15,4.59-10.07,1.78-.3-.4-.49-.94-.59-1.48l2.47-.4c.15,2.27,5.53,2.77,5.73.25-.84-3.41-7.41-.49-7.6-5.63-.2-4.3,7.56-4.35,9.28-1.73.25.4.4.89.49,1.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "microsites-phase5-2",
    d: "M80.8,120.74c3.95,0,6.17,2.22,6.17,6.22s-2.27,6.37-6.22,6.37-6.12-2.37-6.12-6.37,2.17-6.22,6.17-6.22ZM80.75,131.31c2.57,0,3.6-1.73,3.6-4.35,0-2.47-1.04-4.25-3.56-4.25s-3.6,1.73-3.6,4.25,1.09,4.35,3.56,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    className: "microsites-phase5-2",
    d: "M97.54,133.14l-1.09-3.11h-4.64l-1.09,3.11h-2.57l4.44-12.25h3.01l4.44,12.25h-2.52ZM95.91,128.1l-1.78-5.33c-.49,1.88-1.19,3.56-1.78,5.33h3.56"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "microsites-phase5-2",
    d: "M111.37,131.46c-.79.94-1.48,1.93-3.16,1.88-1.83-.05-2.86-.99-2.86-2.86-.05-2.96,2.72-3.11,5.73-3.01.05-1.28-.15-2.32-1.38-2.32-.89.05-1.28.44-1.38,1.33l-2.57-.1c.35-1.88,1.78-2.86,4.05-2.81s3.65,1.09,3.7,3.36l.05,4.05c-.05.69.59.89,1.23.74v1.33c-1.48.4-3.51.25-3.41-1.58ZM109,131.61c1.43,0,2.12-1.19,2.07-2.81-1.58,0-3.26-.15-3.21,1.48,0,.84.4,1.33,1.14,1.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    className: "microsites-phase5-2",
    d: "M124.06,130.03c-.35,2.07-1.88,3.31-4.25,3.31-2.91,0-4.15-1.88-4.44-4.84-.59-5.43,7.6-6.77,8.59-1.78l-2.42.1c-.1-.94-.74-1.58-1.73-1.58-1.48,0-1.73,1.38-1.88,3.16-.3,3.65,3.21,4.3,3.65,1.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    className: "microsites-phase5-2",
    d: "M130.23,132.99c-1.78.69-4.3.35-4.3-2.07v-5.53h-1.19v-1.63h1.33l.74-2.22h1.53v2.22h1.78v1.63h-1.78v4.89c-.05,1.14.79,1.53,1.88,1.23v1.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    className: "microsites-phase5-2",
    d: "M131.67,122.08v-1.83h2.47v1.83h-2.47ZM131.67,133.14v-9.38h2.47v9.38h-2.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X",
    className: "microsites-phase5-2",
    d: "M140.8,123.56c3.16,0,4.74,1.78,4.74,4.89s-1.73,4.89-4.79,4.89-4.69-1.78-4.69-4.89,1.68-4.89,4.74-4.89ZM140.75,131.66c1.73,0,2.22-1.38,2.22-3.21,0-1.98-.49-3.21-2.12-3.21s-2.22,1.28-2.22,3.21c0,1.78.49,3.21,2.12,3.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "microsites-phase5-2",
    d: "M152.85,123.56c4.3-.05,2.86,5.58,3.11,9.58h-2.47c-.35-2.81,1.14-7.75-1.68-7.75s-1.68,4.79-1.93,7.75h-2.47l-.05-9.38h2.32c.1.59-.05,1.38.15,1.88.59-1.28,1.38-2.02,3.01-2.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z",
    className: "microsites-phase5-2",
    d: "M163.76,126.33c.05-1.43-3.46-1.68-3.51-.2.74,2.27,5.83.35,5.88,4.25.05,4.1-8.1,3.75-8.49.44l2.12-.35c.2.94.99,1.23,2.17,1.23,1.63.4,2.81-1.48,1.19-2.02-2.12-.69-5.04-.54-5.14-3.26-.1-3.95,7.6-3.65,7.95-.35"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T-2",
    "data-name": "T",
    className: "microsites-phase5-2",
    d: "M178.38,131.46c-.79.94-1.48,1.93-3.16,1.88-1.83-.05-2.86-.99-2.86-2.86-.05-2.96,2.72-3.11,5.73-3.01.05-1.28-.15-2.32-1.38-2.32-.89.05-1.28.44-1.38,1.33l-2.57-.1c.35-1.88,1.78-2.86,4.05-2.81s3.65,1.09,3.7,3.36l.05,4.05c-.05.69.59.89,1.23.74v1.33c-1.48.4-3.51.25-3.41-1.58ZM176.01,131.61c1.43,0,2.12-1.19,2.07-2.81-1.58,0-3.26-.15-3.21,1.48,0,.84.4,1.33,1.14,1.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-2",
    "data-name": "Y",
    className: "microsites-phase5-2",
    d: "M188.36,123.56c4.3-.05,2.86,5.58,3.11,9.58h-2.47c-.35-2.81,1.14-7.75-1.68-7.75s-1.68,4.79-1.93,7.75h-2.47l-.05-9.38h2.32c.1.59-.05,1.38.15,1.88.59-1.28,1.38-2.02,3.01-2.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "microsites-phase5-2",
    d: "M196.85,123.56c1.53-.05,2.27.74,2.86,1.68l-.05-4.99h2.47l.05,12.89h-2.37c-.1-.49,0-1.14-.15-1.53-.54,1.14-1.43,1.73-3.01,1.73-2.57,0-3.36-2.22-3.41-4.89,0-2.77.94-4.79,3.6-4.89ZM197.69,131.66c1.63,0,1.98-1.48,2.02-3.26.05-1.83-.44-3.16-2.02-3.16s-1.88,1.48-1.93,3.21c0,2.12.64,3.21,1.93,3.21"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "U-2",
    "data-name": "U",
    className: "microsites-phase5-2",
    d: "M217.64,130.03c-.35,2.07-1.88,3.31-4.25,3.31-2.91,0-4.15-1.88-4.44-4.84-.59-5.43,7.6-6.77,8.59-1.78l-2.42.1c-.1-.94-.74-1.58-1.73-1.58-1.48,0-1.73,1.38-1.88,3.16-.3,3.65,3.21,4.3,3.65,1.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-2",
    "data-name": "X",
    className: "microsites-phase5-2",
    d: "M223.57,123.56c3.16,0,4.74,1.78,4.74,4.89s-1.73,4.89-4.79,4.89-4.69-1.78-4.69-4.89,1.68-4.89,4.74-4.89ZM223.52,131.66c1.73,0,2.22-1.38,2.22-3.21,0-1.98-.49-3.21-2.12-3.21s-2.22,1.28-2.22,3.21c0,1.78.49,3.21,2.12,3.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-3",
    "data-name": "Y",
    className: "microsites-phase5-2",
    d: "M235.62,123.56c4.3-.05,2.86,5.58,3.11,9.58h-2.47c-.35-2.81,1.14-7.75-1.68-7.75s-1.68,4.79-1.93,7.75h-2.47l-.05-9.38h2.32c.1.59-.05,1.38.15,1.88.59-1.28,1.38-2.02,3.01-2.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "microsites-phase5-2",
    d: "M245.74,121.98c-1.33-.35-2.12.25-1.88,1.78h1.88v1.63h-1.88v7.75h-2.42v-7.75h-1.38v-1.63h1.38c-.44-2.91,1.58-4,4.3-3.36v1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-2",
    "data-name": "W",
    className: "microsites-phase5-2",
    d: "M246.88,122.08v-1.83h2.47v1.83h-2.47ZM246.88,133.14v-9.38h2.47v9.38h-2.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "microsites-phase5-2",
    d: "M257.25,125.73c-1.93-.59-2.96.64-2.96,2.81v4.59h-2.47l-.05-9.38h2.32c.1.64-.05,1.43.15,1.98.3-1.38,1.33-2.62,3.01-2.02v2.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "microsites-phase5-2",
    d: "M268.36,125.39c-2.62.44-1.38,4.94-1.68,7.75h-2.42v-5.28c.05-1.33-.25-2.42-1.43-2.47-2.62.49-1.33,4.94-1.63,7.75h-2.47l-.05-9.38h2.32c.1.59-.05,1.38.15,1.88.49-2.62,4.99-2.77,5.33,0,.64-1.09,1.19-2.12,2.91-2.07,4.05.05,2.52,5.73,2.81,9.58h-2.42v-5.28c-.05-1.23-.25-2.37-1.43-2.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-2",
    "data-name": "Z",
    className: "microsites-phase5-2",
    d: "M280.06,126.33c.05-1.43-3.46-1.68-3.51-.2.74,2.27,5.83.35,5.88,4.25.05,4.1-8.1,3.75-8.49.44l2.12-.35c.2.94.99,1.23,2.17,1.23,1.63.4,2.81-1.48,1.19-2.02-2.12-.69-5.04-.54-5.14-3.26-.1-3.95,7.6-3.65,7.95-.35"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-7",
    d: "M172.6,269.64v28.65"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-5",
    d: "M173.1,269.65h-1v-.5h1v.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-4",
    d: "M172.6,313.05l-4.64-14.26h9.28l-4.64,14.26Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-disable-phase5",
    d: "M.5,6.5C.5,3.19,3.19.5,6.5.5h332.2c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6V6.5Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "microsites-phase5-3",
    d: "M35.74,28.84l-1.73-4.44h-6.98l-1.73,4.44h-2.16l6.23-15.31h2.35l6.11,15.31h-2.1ZM33.4,22.73l-2.9-7.59c-.74,2.78-1.91,5.06-2.84,7.59h5.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af",
    className: "microsites-phase5-3",
    d: "M43.15,16.87c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM43.71,18.35c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "microsites-phase5-3",
    d: "M56.92,28.84h-2.35l-4.26-11.73h2.1l3.33,10.19,3.46-10.19h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah",
    className: "microsites-phase5-3",
    d: "M62.84,14.58v-1.85h1.98v1.85h-1.98ZM62.84,28.84v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "microsites-phase5-3",
    d: "M74.57,20.02c-.19-2.1-5.31-2.35-5.37,0,.93,3.27,7.1.74,7.35,5.56s-9.26,4.57-9.69.49l1.73-.31c.25,2.22,5.99,2.78,6.05,0-.62-3.46-6.98-.93-7.28-5.56-.25-3.52,5.06-3.89,7.53-2.59.74.43,1.3,1.17,1.48,2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj",
    className: "microsites-phase5-3",
    d: "M83.52,16.87c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM86.73,21.87c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "microsites-phase5-3",
    d: "M107.29,17.18c-.31-2.96-7.59-3.33-7.65.12.86,4.63,9.75.86,10.06,7.35.19,4.81-7.47,5.37-10.8,3.4-1.05-.62-1.73-1.6-2.04-2.84l2.04-.43c.31,3.46,8.7,3.89,8.7-.06,0-4.81-9.57-.86-10-7.28-.31-5.06,8.95-5.19,11.05-2.1.31.43.49.99.68,1.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al",
    className: "microsites-phase5-3",
    d: "M119.32,13.35c5,0,7.59,2.84,7.59,7.78s-2.72,7.96-7.59,7.96-7.59-3.02-7.59-7.96,2.59-7.78,7.59-7.78ZM119.32,27.36c3.89,0,5.49-2.53,5.49-6.23s-1.79-6.11-5.49-6.11-5.49,2.41-5.49,6.11,1.73,6.17,5.49,6.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-2",
    "data-name": "ae",
    className: "microsites-phase5-3",
    d: "M140.62,28.84l-1.73-4.44h-6.98l-1.73,4.44h-2.16l6.23-15.31h2.35l6.11,15.31h-2.1ZM138.27,22.73l-2.9-7.59c-.74,2.78-1.91,5.06-2.84,7.59h5.74"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "microsites-phase5-3",
    d: "M151.36,25.94c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "microsites-phase5-3",
    d: "M160.06,16.87c3.83-.06,5.25,2.28,5.25,6.11.06,3.89-1.67,6.11-5.31,6.11s-5.12-2.41-5.19-6.11c0-4.07,1.73-6.11,5.25-6.11ZM160,27.61c2.72.06,3.27-1.91,3.27-4.63s-.49-4.63-3.15-4.63-3.27,1.98-3.27,4.63.62,4.57,3.15,4.63"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "microsites-phase5-3",
    d: "M179.51,16.87c3.4.06,4.32,2.53,4.32,6.05s-.99,6.05-4.32,6.17c-1.91,0-3.02-.8-3.7-2.1l.06,6.48h-1.98l-.06-16.36h1.91l.12,1.85c.62-1.3,1.73-2.1,3.64-2.1ZM179.01,27.61c2.47,0,2.78-2.1,2.78-4.63s-.37-4.51-2.78-4.57c-2.59,0-3.15,1.98-3.15,4.69s.62,4.51,3.15,4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "microsites-phase5-3",
    d: "M189.94,29.09c-5.49.25-3.33-7.16-3.77-11.98h1.98v7.41c0,1.91.43,3.09,2.41,3.02,4.44-.12,2.78-6.23,3.09-10.43h1.91l.06,11.73h-1.85c-.06-.62.06-1.54-.12-2.04-.68,1.36-1.73,2.22-3.7,2.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "microsites-phase5-3",
    d: "M198.58,28.84V12.73h1.98v16.11h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-2",
    "data-name": "aq",
    className: "microsites-phase5-3",
    d: "M203.46,28.84V12.73h1.98v16.11h-1.98"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "am-2",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M216.67,25.94c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "microsites-phase5-3",
    d: "M225.74,18.41c-4.44,0-2.72,6.3-3.02,10.43h-1.98V12.73h1.98l-.06,6.36c.74-1.3,1.73-2.22,3.77-2.22,5.49,0,3.27,7.16,3.7,11.98h-1.98v-7.47c.12-1.98-.49-3.02-2.41-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-2",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M237.72,16.87c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM240.93,21.87c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as",
    className: "microsites-phase5-3",
    d: "M255.99,18.41c-2.47,0-2.96,2.04-2.96,4.51s.56,4.63,2.96,4.63c1.48,0,2.53-.86,2.65-2.35l1.98.12c-.37,2.28-1.91,3.77-4.57,3.77-3.64,0-4.69-2.53-5.06-6.11-.62-5.74,6.23-8.09,9.07-3.95.25.43.31.86.43,1.36l-1.98.19c-.25-1.3-.99-2.16-2.53-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-2",
    "data-name": "an",
    className: "microsites-phase5-3",
    d: "M267.35,16.87c3.83-.06,5.25,2.28,5.25,6.11.06,3.89-1.67,6.11-5.31,6.11s-5.12-2.41-5.19-6.11c0-4.07,1.73-6.11,5.25-6.11ZM267.29,27.61c2.72.06,3.27-1.91,3.27-4.63s-.49-4.63-3.15-4.63-3.27,1.98-3.27,4.63.62,4.57,3.15,4.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at",
    className: "microsites-phase5-3",
    d: "M280.74,16.87c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-3",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M289.51,25.94c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-3",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M298.21,16.87c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM301.42,21.87c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-2",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M311.61,16.87c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-4",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M320.37,25.94c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af-2",
    "data-name": "af",
    className: "microsites-phase5-3",
    d: "M24.08,43.54c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM24.63,45.02c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-3",
    "data-name": "an",
    className: "microsites-phase5-3",
    d: "M37.35,43.54c3.83-.06,5.25,2.28,5.25,6.11.06,3.89-1.67,6.11-5.31,6.11s-5.12-2.41-5.19-6.11c0-4.07,1.73-6.11,5.25-6.11ZM37.29,54.28c2.72.06,3.27-1.91,3.27-4.63s-.49-4.63-3.15-4.63-3.27,1.98-3.27,4.63.62,4.57,3.15,4.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au",
    className: "microsites-phase5-3",
    d: "M56.24,55.51h-2.22l-2.47-10.12-2.53,10.12h-2.22l-3.33-11.73h1.98l2.41,10.12,2.65-10.12h2.1l2.53,10.12,2.59-10.12h1.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-3",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M66.73,43.54c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av",
    className: "microsites-phase5-3",
    d: "M86.73,53.29c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM80.99,52.24c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-4",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M97.59,43.54c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-3",
    "data-name": "af",
    className: "microsites-phase5-3",
    d: "M107.96,43.54c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM108.52,45.02c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-2",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M129.94,53.29c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM124.2,52.24c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-5",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M140.8,43.54c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw",
    className: "microsites-phase5-3",
    d: "M156.98,43.78l-5.31,13.64c-.86,1.73-2.28,3.15-5,2.59v-1.48c2.41.37,3.27-1.23,3.95-3.09l-4.63-11.67h2.1l3.52,9.63,3.33-9.63h2.04"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ah-2",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M164.69,41.25v-1.85h1.98v1.85h-1.98ZM164.69,55.51v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax",
    className: "microsites-phase5-3",
    d: "M181.05,45.08c-4.14.19-2.35,6.48-2.72,10.43h-1.91v-7.47c0-1.79-.31-3.09-2.16-2.96-4.07.25-2.35,6.42-2.72,10.43h-1.91l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.62-2.72,6.11-3.09,6.6,0,.68-1.3,1.67-2.16,3.58-2.22,5.25-.12,2.9,7.35,3.4,11.98h-1.91v-7.47c0-1.79-.31-3.02-2.16-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-2",
    "data-name": "ao",
    className: "microsites-phase5-3",
    d: "M193.64,43.54c3.4.06,4.32,2.53,4.32,6.05s-.99,6.05-4.32,6.17c-1.91,0-3.02-.8-3.7-2.1l.06,6.48h-1.98l-.06-16.36h1.91l.12,1.85c.62-1.3,1.73-2.1,3.64-2.1ZM193.15,54.28c2.47,0,2.78-2.1,2.78-4.63s-.37-4.51-2.78-4.57c-2.59,0-3.15,1.98-3.15,4.69s.62,4.51,3.15,4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-3",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M207.59,53.29c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM201.85,52.24c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-2",
    "data-name": "as",
    className: "microsites-phase5-3",
    d: "M217.16,45.08c-2.47,0-2.96,2.04-2.96,4.51s.56,4.63,2.96,4.63c1.48,0,2.53-.86,2.65-2.35l1.98.12c-.37,2.28-1.91,3.77-4.57,3.77-3.64,0-4.69-2.53-5.06-6.11-.62-5.74,6.23-8.09,9.07-3.95.25.43.31.86.43,1.36l-1.98.19c-.25-1.3-.99-2.16-2.53-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-5",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M225.99,52.61c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-4",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M234.69,43.54c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM237.9,48.54c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-4",
    "data-name": "af",
    className: "microsites-phase5-3",
    d: "M246.11,43.54c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM246.67,45.02c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ay",
    className: "microsites-phase5-3",
    d: "M266.42,45.45c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-5",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M272.9,43.54c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM276.11,48.54c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-3",
    "data-name": "aq",
    className: "microsites-phase5-3",
    d: "M280.56,55.51v-16.11h1.98v16.11h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-4",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M292.66,53.29c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM286.92,52.24c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-6",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M299.94,52.61c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-6",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M308.64,43.54c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM311.85,48.54c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-5",
    "data-name": "af",
    className: "microsites-phase5-3",
    d: "M320.06,43.54c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM320.62,45.02c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ao-3",
    "data-name": "ao",
    className: "microsites-phase5-3",
    d: "M148.03,70.2c3.4.06,4.32,2.53,4.32,6.05s-.99,6.05-4.32,6.17c-1.91,0-3.02-.8-3.7-2.1l.06,6.48h-1.98l-.06-16.36h1.91l.12,1.85c.62-1.3,1.73-2.1,3.64-2.1ZM147.53,80.94c2.47,0,2.78-2.1,2.78-4.63s-.37-4.51-2.78-4.57c-2.59,0-3.15,1.98-3.15,4.69s.62,4.51,3.15,4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-3",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M154.75,67.92v-1.85h1.98v1.85h-1.98ZM154.75,82.18v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-7",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M164.32,70.2c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM167.53,75.2c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-3",
    "data-name": "as",
    className: "microsites-phase5-3",
    d: "M176.42,71.75c-2.47,0-2.96,2.04-2.96,4.51s.56,4.63,2.96,4.63c1.48,0,2.53-.86,2.65-2.35l1.98.12c-.37,2.28-1.91,3.77-4.57,3.77-3.64,0-4.69-2.53-5.06-6.11-.62-5.74,6.23-8.09,9.07-3.95.25.43.31.86.43,1.36l-1.98.19c-.25-1.3-.99-2.16-2.53-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-8",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M187.78,70.2c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM190.99,75.2c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-2",
    "data-name": "ai",
    className: "microsites-phase5-3",
    d: "M202.29,73.35c-.19-2.1-5.31-2.35-5.37,0,.93,3.27,7.1.74,7.35,5.56s-9.26,4.57-9.69.49l1.73-.31c.25,2.22,5.99,2.78,6.05,0-.62-3.46-6.98-.93-7.28-5.56-.25-3.52,5.06-3.89,7.53-2.59.74.43,1.3,1.17,1.48,2.16"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-disable-phase5",
    d: "M.5,175.97c0-3.31,2.69-6,6-6h332.2c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-86.67Z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "az",
    className: "microsites-phase5-3",
    d: "M40.21,196.28c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-2",
    "data-name": "ar",
    className: "microsites-phase5-3",
    d: "M50.6,196.96c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-9",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M63.78,195.26c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM67.31,200.76c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-4",
    "data-name": "as",
    className: "microsites-phase5-3",
    d: "M77.09,196.96c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA",
    className: "microsites-phase5-3",
    d: "M92.5,208.44l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "am-7",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M105.81,205.24c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-4",
    "data-name": "an",
    className: "microsites-phase5-3",
    d: "M115.38,195.26c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM115.31,207.08c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as-5",
    "data-name": "as",
    className: "microsites-phase5-3",
    d: "M135.48,196.96c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-5",
    "data-name": "an",
    className: "microsites-phase5-3",
    d: "M147.97,195.26c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM147.91,207.08c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-6",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M162.71,195.26c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB",
    className: "microsites-phase5-3",
    d: "M175.2,192.55c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-4",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M176.76,192.75v-2.04h2.17v2.04h-2.17ZM176.76,208.44v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-2",
    "data-name": "ay",
    className: "microsites-phase5-3",
    d: "M188.24,197.37c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-2",
    "data-name": "ax",
    className: "microsites-phase5-3",
    d: "M202.84,196.96c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as-6",
    "data-name": "as",
    className: "microsites-phase5-3",
    d: "M222.19,196.96c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-6",
    "data-name": "an",
    className: "microsites-phase5-3",
    d: "M234.68,195.26c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM234.62,207.08c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-7",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M249.42,195.26c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-8",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M259.06,205.24c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-10",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M268.63,195.26c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM272.17,200.76c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-8",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M283.37,195.26c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-9",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M293.01,205.24c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ah-5",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M304.21,192.75v-2.04h2.17v2.04h-2.17ZM304.21,208.44v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-3",
    "data-name": "ai",
    className: "microsites-phase5-3",
    d: "M317.12,198.73c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ao-4",
    "data-name": "ao",
    className: "microsites-phase5-3",
    d: "M148.28,224.6c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM147.74,236.41c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-2",
    "data-name": "ap",
    className: "microsites-phase5-3",
    d: "M159.75,238.04c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-4",
    "data-name": "aq",
    className: "microsites-phase5-3",
    d: "M169.26,237.77v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-5",
    "data-name": "aq",
    className: "microsites-phase5-3",
    d: "M174.63,237.77v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-11",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M185.15,224.6c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM188.68,230.1c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-6",
    "data-name": "af",
    className: "microsites-phase5-3",
    d: "M197.71,224.6c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM198.32,226.23c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-disable-phase5",
    d: "M.5,321.17c0-3.31,2.69-6,6-6h332.2c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-86.67Z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC",
    className: "microsites-phase5-3",
    d: "M43.77,348.89c-.06,4.01-2.47,5.99-6.42,5.99s-6.17-1.98-6.17-5.8v-9.75h2.04c.49,5.49-2.04,13.83,4.14,13.83s3.95-8.21,4.38-13.83h2.04v9.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-5",
    "data-name": "ao",
    className: "microsites-phase5-3",
    d: "M52.53,342.66c3.4.06,4.32,2.53,4.32,6.05s-.99,6.05-4.32,6.17c-1.91,0-3.02-.8-3.7-2.1l.06,6.48h-1.98l-.06-16.36h1.91l.12,1.85c.62-1.3,1.73-2.1,3.64-2.1ZM52.04,353.4c2.47,0,2.78-2.1,2.78-4.63s-.37-4.51-2.78-4.57c-2.59,0-3.15,1.98-3.15,4.69s.62,4.51,3.15,4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-6",
    "data-name": "aq",
    className: "microsites-phase5-3",
    d: "M59.26,354.64v-16.11h1.98v16.11h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-7",
    "data-name": "an",
    className: "microsites-phase5-3",
    d: "M68.83,342.66c3.83-.06,5.25,2.28,5.25,6.11.06,3.89-1.67,6.11-5.31,6.11s-5.12-2.41-5.19-6.11c0-4.07,1.73-6.11,5.25-6.11ZM68.77,353.4c2.72.06,3.27-1.91,3.27-4.63s-.49-4.63-3.15-4.63-3.27,1.98-3.27,4.63.62,4.57,3.15,4.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-5",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M83.71,352.41c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM77.96,351.36c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-7",
    "data-name": "af",
    className: "microsites-phase5-3",
    d: "M92.59,342.66c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM93.15,344.14c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as-7",
    "data-name": "as",
    className: "microsites-phase5-3",
    d: "M111.79,344.2c-2.47,0-2.96,2.04-2.96,4.51s.56,4.63,2.96,4.63c1.48,0,2.53-.86,2.65-2.35l1.98.12c-.37,2.28-1.91,3.77-4.57,3.77-3.64,0-4.69-2.53-5.06-6.11-.62-5.74,6.23-8.09,9.07-3.95.25.43.31.86.43,1.36l-1.98.19c-.25-1.3-.99-2.16-2.53-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-8",
    "data-name": "an",
    className: "microsites-phase5-3",
    d: "M123.15,342.66c3.83-.06,5.25,2.28,5.25,6.11.06,3.89-1.67,6.11-5.31,6.11s-5.12-2.41-5.19-6.11c0-4.07,1.73-6.11,5.25-6.11ZM123.09,353.4c2.72.06,3.27-1.91,3.27-4.63s-.49-4.63-3.15-4.63-3.27,1.98-3.27,4.63.62,4.57,3.15,4.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-9",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M136.54,342.66c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-2",
    "data-name": "aB",
    className: "microsites-phase5-3",
    d: "M147.9,340.19c-1.91-.56-2.59.62-2.35,2.72h2.35v1.42h-2.35v10.31h-1.91v-10.31h-1.67v-1.42h1.67c-.43-3.21,1.05-5.06,4.26-4.2v1.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-6",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M149.32,340.38v-1.85h1.98v1.85h-1.98ZM149.32,354.64v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-3",
    "data-name": "ay",
    className: "microsites-phase5-3",
    d: "M159.75,344.57c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-3",
    "data-name": "ax",
    className: "microsites-phase5-3",
    d: "M173.03,344.2c-4.14.19-2.35,6.48-2.72,10.43h-1.91v-7.47c0-1.79-.31-3.09-2.16-2.96-4.07.25-2.35,6.42-2.72,10.43h-1.91l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.62-2.72,6.11-3.09,6.6,0,.68-1.3,1.67-2.16,3.58-2.22,5.25-.12,2.9,7.35,3.4,11.98h-1.91v-7.47c0-1.79-.31-3.02-2.16-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-6",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M187.22,352.41c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM181.48,351.36c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-10",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M194.51,351.73c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-7",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M198.52,340.38v-1.85h1.98v1.85h-1.98ZM198.52,354.64v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-9",
    "data-name": "an",
    className: "microsites-phase5-3",
    d: "M208.09,342.66c3.83-.06,5.25,2.28,5.25,6.11.06,3.89-1.67,6.11-5.31,6.11s-5.12-2.41-5.19-6.11c0-4.07,1.73-6.11,5.25-6.11ZM208.03,353.4c2.72.06,3.27-1.91,3.27-4.63s-.49-4.63-3.15-4.63-3.27,1.98-3.27,4.63.62,4.57,3.15,4.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-10",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M221.48,342.66c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aj-12",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M238.95,342.66c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM242.16,347.66c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-4",
    "data-name": "ax",
    className: "microsites-phase5-3",
    d: "M258.09,344.2c-4.14.19-2.35,6.48-2.72,10.43h-1.91v-7.47c0-1.79-.31-3.09-2.16-2.96-4.07.25-2.35,6.42-2.72,10.43h-1.91l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.62-2.72,6.11-3.09,6.6,0,.68-1.3,1.67-2.16,3.58-2.22,5.25-.12,2.9,7.35,3.4,11.98h-1.91v-7.47c0-1.79-.31-3.02-2.16-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-7",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M272.29,352.41c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM266.54,351.36c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-8",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M277.41,340.38v-1.85h1.98v1.85h-1.98ZM277.41,354.64v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-7",
    "data-name": "aq",
    className: "microsites-phase5-3",
    d: "M282.29,354.64v-16.11h1.98v16.11h-1.98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an-10",
    "data-name": "an",
    className: "microsites-phase5-3",
    d: "M298.03,342.66c3.83-.06,5.25,2.28,5.25,6.11.06,3.89-1.67,6.11-5.31,6.11s-5.12-2.41-5.19-6.11c0-4.07,1.73-6.11,5.25-6.11ZM297.96,353.4c2.72.06,3.27-1.91,3.27-4.63s-.49-4.63-3.15-4.63-3.27,1.98-3.27,4.63.62,4.57,3.15,4.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-11",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M311.42,342.66c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aD",
    className: "microsites-phase5-3",
    d: "M74.69,381.3h-2.1l-6.23-15.31h2.16l5.12,13.46,5.12-13.46h2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-13",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M85.99,369.33c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM89.2,374.33c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-14",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M98.34,369.33c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM101.54,374.33c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-2",
    "data-name": "ag",
    className: "microsites-phase5-3",
    d: "M111.17,381.3h-2.35l-4.26-11.73h2.1l3.33,10.19,3.46-10.19h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-8",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M124.32,379.08c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM118.58,378.03c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-9",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M149.01,379.08c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM143.27,378.03c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-4",
    "data-name": "ai",
    className: "microsites-phase5-3",
    d: "M160.99,372.47c-.19-2.1-5.31-2.35-5.37,0,.93,3.27,7.1.74,7.35,5.56s-9.26,4.57-9.69.49l1.73-.31c.25,2.22,5.99,2.78,6.05,0-.62-3.46-6.98-.93-7.28-5.56-.25-3.52,5.06-3.89,7.53-2.59.74.43,1.3,1.17,1.48,2.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-10",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M178.64,379.08c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM172.9,378.03c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-11",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M185.93,378.4c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-12",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M192.1,378.4c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-11",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M203.34,379.08c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM197.59,378.03c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-8",
    "data-name": "as",
    className: "microsites-phase5-3",
    d: "M212.9,370.87c-2.47,0-2.96,2.04-2.96,4.51s.56,4.63,2.96,4.63c1.48,0,2.53-.86,2.65-2.35l1.98.12c-.37,2.28-1.91,3.77-4.57,3.77-3.64,0-4.69-2.53-5.06-6.11-.62-5.74,6.23-8.09,9.07-3.95.25.43.31.86.43,1.36l-1.98.19c-.25-1.3-.99-2.16-2.53-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-3",
    "data-name": "ar",
    className: "microsites-phase5-3",
    d: "M224.63,370.87c-4.44,0-2.72,6.3-3.02,10.43h-1.98v-16.11h1.98l-.06,6.36c.74-1.3,1.73-2.22,3.77-2.22,5.49,0,3.27,7.16,3.7,11.98h-1.98v-7.47c.12-1.98-.49-3.02-2.41-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-5",
    "data-name": "ax",
    className: "microsites-phase5-3",
    d: "M243.4,370.87c-4.14.19-2.35,6.48-2.72,10.43h-1.91v-7.47c0-1.79-.31-3.09-2.16-2.96-4.07.25-2.35,6.42-2.72,10.43h-1.91l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.62-2.72,6.11-3.09,6.6,0,.68-1.3,1.67-2.16,3.58-2.22,5.25-.12,2.9,7.35,3.4,11.98h-1.91v-7.47c0-1.79-.31-3.02-2.16-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-15",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M255.06,369.33c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM258.27,374.33c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-12",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M268.46,369.33c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-13",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M277.22,378.4c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-disable-phase5",
    d: "M.5,519.52c0-3.31,2.69-6,6-6h582.63c3.31,0,6,2.69,6,6v86.65c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-86.65Z"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aE",
    className: "microsites-phase5-3",
    d: "M67.04,555.96c-.06,2.53-1.42,3.95-3.7,4.32l4.32,6.6h-2.35l-4.01-6.36h-4.75v6.36h-2.04v-15.31c5.43.19,12.65-1.3,12.53,4.38ZM56.54,558.93c3.7-.12,8.46.8,8.46-2.9s-4.94-2.59-8.46-2.78v5.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-16",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M74.82,554.91c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM78.03,559.91c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-14",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M84.63,563.99c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-9",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M88.64,552.63v-1.85h1.98v1.85h-1.98ZM88.64,566.89v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-4",
    "data-name": "ay",
    className: "microsites-phase5-3",
    d: "M99.08,556.83c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-17",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M105.56,554.91c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM108.77,559.91c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i-2",
    "data-name": "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "am-15",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M121.55,563.99c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-4",
    "data-name": "ar",
    className: "microsites-phase5-3",
    d: "M130.62,556.46c-4.44,0-2.72,6.3-3.02,10.43h-1.98v-16.11h1.98l-.06,6.36c.74-1.3,1.73-2.22,3.77-2.22,5.49,0,3.27,7.16,3.7,11.98h-1.98v-7.47c.12-1.98-.49-3.02-2.41-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-18",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M142.59,554.91c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM145.8,559.91c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ao-6",
    "data-name": "ao",
    className: "microsites-phase5-3",
    d: "M162.04,554.91c3.4.06,4.32,2.53,4.32,6.05s-.99,6.05-4.32,6.17c-1.91,0-3.02-.8-3.7-2.1l.06,6.48h-1.98l-.06-16.36h1.91l.12,1.85c.62-1.3,1.73-2.1,3.64-2.1ZM161.54,565.65c2.47,0,2.78-2.1,2.78-4.63s-.37-4.51-2.78-4.57c-2.59,0-3.15,1.98-3.15,4.69s.62,4.51,3.15,4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-10",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M168.77,552.63v-1.85h1.98v1.85h-1.98ZM168.77,566.89v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-19",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M178.34,554.91c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM181.54,559.91c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-9",
    "data-name": "as",
    className: "microsites-phase5-3",
    d: "M190.43,556.46c-2.47,0-2.96,2.04-2.96,4.51s.56,4.63,2.96,4.63c1.48,0,2.53-.86,2.65-2.35l1.98.12c-.37,2.28-1.91,3.77-4.57,3.77-3.64,0-4.69-2.53-5.06-6.11-.62-5.74,6.23-8.09,9.07-3.95.25.43.31.86.43,1.36l-1.98.19c-.25-1.3-.99-2.16-2.53-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-20",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M201.79,554.91c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM205,559.91c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "l-2",
    "data-name": "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-12",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M222.84,564.67c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM217.1,563.62c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-13",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M233.71,554.91c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-8",
    "data-name": "af",
    className: "microsites-phase5-3",
    d: "M244.08,554.91c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM244.63,556.39c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m-2",
    "data-name": "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-13",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M266.05,564.67c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM260.31,563.62c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-14",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M276.92,554.91c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-2",
    "data-name": "aw",
    className: "microsites-phase5-3",
    d: "M293.09,555.16l-5.31,13.64c-.86,1.73-2.28,3.15-5,2.59v-1.48c2.41.37,3.27-1.23,3.95-3.09l-4.63-11.67h2.1l3.52,9.63,3.33-9.63h2.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ay-5",
    "data-name": "ay",
    className: "microsites-phase5-3",
    d: "M306.36,556.83c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-21",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M312.84,554.91c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM316.05,559.91c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-8",
    "data-name": "aq",
    className: "microsites-phase5-3",
    d: "M320.5,566.89v-16.11h1.98v16.11h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-14",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M332.59,564.67c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM326.85,563.62c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-16",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M339.88,563.99c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-22",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M348.58,554.91c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM351.79,559.91c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-9",
    "data-name": "af",
    className: "microsites-phase5-3",
    d: "M360,554.91c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM360.56,556.39c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ax-6",
    "data-name": "ax",
    className: "microsites-phase5-3",
    d: "M386.24,556.46c-4.14.19-2.35,6.48-2.72,10.43h-1.91v-7.47c0-1.79-.31-3.09-2.16-2.96-4.07.25-2.35,6.42-2.72,10.43h-1.91l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.62-2.72,6.11-3.09,6.6,0,.68-1.3,1.67-2.16,3.58-2.22,5.25-.12,2.9,7.35,3.4,11.98h-1.91v-7.47c0-1.79-.31-3.02-2.16-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-15",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M400.43,564.67c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM394.69,563.62c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-17",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M407.72,563.99c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-23",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M416.42,554.91c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM419.63,559.91c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-6",
    "data-name": "ay",
    className: "microsites-phase5-3",
    d: "M429.63,556.83c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-11",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M431.42,552.63v-1.85h1.98v1.85h-1.98ZM431.42,566.89v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-16",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M443.52,564.67c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM437.78,563.62c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-9",
    "data-name": "aq",
    className: "microsites-phase5-3",
    d: "M448.64,566.89v-16.11h1.98v16.11h-1.98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ah-12",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M459.69,552.63v-1.85h1.98v1.85h-1.98ZM459.69,566.89v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-15",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M470.31,554.91c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aD-2",
    "data-name": "aD",
    className: "microsites-phase5-3",
    d: "M490.06,566.89h-2.1l-6.23-15.31h2.16l5.12,13.46,5.12-13.46h2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-24",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M501.36,554.91c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM504.57,559.91c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-25",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M513.71,554.91c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM516.92,559.91c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-3",
    "data-name": "ag",
    className: "microsites-phase5-3",
    d: "M526.54,566.89h-2.35l-4.26-11.73h2.1l3.33,10.19,3.46-10.19h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-17",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M539.69,564.67c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM533.95,563.62c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-disable-phase5",
    d: "M441.15,6.5c0-3.31,2.69-6,6-6h141.98c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-141.98c-3.31,0-6-2.69-6-6V6.5Z"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aE-2",
    "data-name": "aE",
    className: "microsites-phase5-3",
    d: "M483.8,22.11c-.05,2.02-1.14,3.16-2.96,3.46l3.46,5.28h-1.88l-3.21-5.09h-3.8v5.09h-1.63v-12.25c4.35.15,10.12-1.04,10.02,3.51ZM475.41,24.48c2.96-.1,6.77.64,6.77-2.32s-3.95-2.07-6.77-2.22v4.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-26",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M490.03,21.27c3.11,0,4.25,2.07,4.15,5.23h-6.67c0,1.98.69,3.31,2.62,3.36,1.28.05,2.12-.59,2.42-1.43l1.38.4c-.54,1.38-1.83,2.22-3.8,2.22-2.86,0-4.35-1.83-4.3-4.94.05-3.01,1.28-4.84,4.2-4.84ZM492.59,25.27c.3-2.96-3.75-3.8-4.79-1.38-.15.35-.3.84-.3,1.38h5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-4",
    "data-name": "ag",
    className: "microsites-phase5-3",
    d: "M500.3,30.85h-1.88l-3.41-9.38h1.68l2.67,8.15,2.77-8.15h1.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-13",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M505.04,19.44v-1.48h1.58v1.48h-1.58ZM505.04,30.85v-9.38h1.58v9.38h-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-27",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M512.69,21.27c3.11,0,4.25,2.07,4.15,5.23h-6.67c0,1.98.69,3.31,2.62,3.36,1.28.05,2.12-.59,2.42-1.43l1.38.4c-.54,1.38-1.83,2.22-3.8,2.22-2.86,0-4.35-1.83-4.3-4.94.05-3.01,1.28-4.84,4.2-4.84ZM515.26,25.27c.3-2.96-3.75-3.8-4.79-1.38-.15.35-.3.84-.3,1.38h5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-2",
    "data-name": "au",
    className: "microsites-phase5-3",
    d: "M527.8,30.85h-1.78l-1.98-8.1-2.02,8.1h-1.78l-2.67-9.38h1.58l1.93,8.1,2.12-8.1h1.68l2.02,8.1,2.07-8.1h1.53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-18",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M542.32,29.07c-.74,1.04-1.53,2.02-3.36,1.98-1.78-.05-2.86-1.04-2.86-2.81-.05-3.16,3.11-3.11,6.17-3.11.15-1.73-.44-2.67-2.02-2.67-1.19.05-2.02.35-2.07,1.53l-1.63-.15c.25-1.83,1.63-2.57,3.75-2.57s3.56.99,3.56,3.16v4.05c-.05.99.35,1.58,1.38,1.33v.99c-1.53.44-3.01-.1-2.91-1.73ZM537.73,28.23c0,.99.59,1.63,1.58,1.63,2.02-.15,3.11-1.43,2.96-3.65-2.12.1-4.54-.25-4.54,2.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-16",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M551.01,21.27c4.4-.2,2.62,5.73,2.96,9.58h-1.58v-5.98c0-1.53-.4-2.42-1.93-2.37-3.56.1-2.17,5.04-2.42,8.35h-1.58l-.05-9.38h1.48c.05.49-.05,1.19.1,1.58.54-1.09,1.43-1.73,3.01-1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-3",
    "data-name": "aw",
    className: "microsites-phase5-3",
    d: "M563.95,21.47l-4.25,10.91c-.69,1.38-1.83,2.52-4,2.07v-1.19c1.93.3,2.62-.99,3.16-2.47l-3.7-9.33h1.68l2.81,7.7,2.67-7.7h1.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ay-7",
    "data-name": "ay",
    className: "microsites-phase5-3",
    d: "M468.54,44.14c-3.85-.79-2.62,4.49-2.81,8.05h-1.58l-.05-9.38h1.48c.05.59-.05,1.43.1,1.93.3-1.33,1.14-2.42,2.86-2.02v1.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-28",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M473.73,42.6c3.11,0,4.25,2.07,4.15,5.23h-6.67c0,1.98.69,3.31,2.62,3.36,1.28.05,2.12-.59,2.42-1.43l1.38.4c-.54,1.38-1.83,2.22-3.8,2.22-2.86,0-4.35-1.83-4.3-4.94.05-3.01,1.28-4.84,4.2-4.84ZM476.3,46.6c.3-2.96-3.75-3.8-4.79-1.38-.15.35-.3.84-.3,1.38h5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-10",
    "data-name": "aq",
    className: "microsites-phase5-3",
    d: "M479.85,52.18v-12.89h1.58v12.89h-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-19",
    "data-name": "av",
    className: "microsites-phase5-3",
    d: "M489.53,50.41c-.74,1.04-1.53,2.02-3.36,1.98-1.78-.05-2.86-1.04-2.86-2.81-.05-3.16,3.11-3.11,6.17-3.11.15-1.73-.44-2.67-2.02-2.67-1.19.05-2.02.35-2.07,1.53l-1.63-.15c.25-1.83,1.63-2.57,3.75-2.57s3.56.99,3.56,3.16v4.05c-.05.99.35,1.58,1.38,1.33v.99c-1.53.44-3.01-.1-2.91-1.73ZM484.94,49.57c0,.99.59,1.63,1.58,1.63,2.02-.15,3.11-1.43,2.96-3.65-2.12.1-4.54-.25-4.54,2.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-18",
    "data-name": "am",
    className: "microsites-phase5-3",
    d: "M495.36,49.86c-.1,1.19.89,1.43,1.88,1.09v1.19c-1.63.49-3.46.25-3.46-1.93v-6.27h-1.09v-1.14h1.19l.44-2.12h1.04v2.12h1.73v1.14h-1.73v5.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-29",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M502.32,42.6c3.11,0,4.25,2.07,4.15,5.23h-6.67c0,1.98.69,3.31,2.62,3.36,1.28.05,2.12-.59,2.42-1.43l1.38.4c-.54,1.38-1.83,2.22-3.8,2.22-2.86,0-4.35-1.83-4.3-4.94.05-3.01,1.28-4.84,4.2-4.84ZM504.89,46.6c.3-2.96-3.75-3.8-4.79-1.38-.15.35-.3.84-.3,1.38h5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-10",
    "data-name": "af",
    className: "microsites-phase5-3",
    d: "M511.46,42.6c1.53,0,2.37.64,2.96,1.63l-.05-4.94h1.58l.05,12.89h-1.48c-.1-.49,0-1.14-.15-1.53-.49,1.14-1.38,1.73-2.91,1.73-2.62,0-3.41-1.93-3.46-4.84,0-3.26,1.14-4.94,3.46-4.94ZM511.9,43.79c-1.98,0-2.27,1.68-2.27,3.7s.3,3.65,2.22,3.65c2.07,0,2.52-1.58,2.52-3.75s-.44-3.65-2.47-3.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ao-7",
    "data-name": "ao",
    className: "microsites-phase5-3",
    d: "M527.75,42.6c2.72.05,3.46,2.02,3.46,4.84s-.79,4.84-3.46,4.94c-1.53,0-2.42-.64-2.96-1.68l.05,5.19h-1.58l-.05-13.09h1.53l.1,1.48c.49-1.04,1.38-1.68,2.91-1.68ZM527.36,51.2c1.98,0,2.22-1.68,2.22-3.7s-.3-3.6-2.22-3.65c-2.07,0-2.52,1.58-2.52,3.75s.49,3.6,2.52,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-14",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M533.14,40.78v-1.48h1.58v1.48h-1.58ZM533.14,52.18v-9.38h1.58v9.38h-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-30",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M540.79,42.6c3.11,0,4.25,2.07,4.15,5.23h-6.67c0,1.98.69,3.31,2.62,3.36,1.28.05,2.12-.59,2.42-1.43l1.38.4c-.54,1.38-1.83,2.22-3.8,2.22-2.86,0-4.35-1.83-4.3-4.94.05-3.01,1.28-4.84,4.2-4.84ZM543.36,46.6c.3-2.96-3.75-3.8-4.79-1.38-.15.35-.3.84-.3,1.38h5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-10",
    "data-name": "as",
    className: "microsites-phase5-3",
    d: "M550.47,43.84c-1.98,0-2.37,1.63-2.37,3.6s.44,3.7,2.37,3.7c1.19,0,2.02-.69,2.12-1.88l1.58.1c-.3,1.83-1.53,3.01-3.65,3.01-2.91,0-3.75-2.02-4.05-4.89-.49-4.59,4.99-6.47,7.26-3.16.2.35.25.69.35,1.09l-1.58.15c-.2-1.04-.79-1.73-2.02-1.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-31",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M559.56,42.6c3.11,0,4.25,2.07,4.15,5.23h-6.67c0,1.98.69,3.31,2.62,3.36,1.28.05,2.12-.59,2.42-1.43l1.38.4c-.54,1.38-1.83,2.22-3.8,2.22-2.86,0-4.35-1.83-4.3-4.94.05-3.01,1.28-4.84,4.2-4.84ZM562.13,46.6c.3-2.96-3.75-3.8-4.79-1.38-.15.35-.3.84-.3,1.38h5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-5",
    "data-name": "ai",
    className: "microsites-phase5-3",
    d: "M571.16,45.12c-.15-1.68-4.25-1.88-4.3,0,.74,2.62,5.68.59,5.88,4.44s-7.41,3.65-7.75.4l1.38-.25c.2,1.78,4.79,2.22,4.84,0-.49-2.77-5.58-.74-5.83-4.44-.2-2.81,4.05-3.11,6.02-2.07.59.35,1.04.94,1.19,1.73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an-11",
    "data-name": "an",
    className: "microsites-phase5-3",
    d: "M467.38,63.94c3.06-.05,4.2,1.83,4.2,4.89.05,3.11-1.33,4.89-4.25,4.89s-4.1-1.93-4.15-4.89c0-3.26,1.38-4.89,4.2-4.89ZM467.34,72.53c2.17.05,2.62-1.53,2.62-3.7s-.4-3.7-2.52-3.7-2.62,1.58-2.62,3.7.49,3.65,2.52,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-3",
    "data-name": "au",
    className: "microsites-phase5-3",
    d: "M482.5,73.52h-1.78l-1.98-8.1-2.02,8.1h-1.78l-2.67-9.38h1.58l1.93,8.1,2.12-8.1h1.68l2.02,8.1,2.07-8.1h1.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-17",
    "data-name": "at",
    className: "microsites-phase5-3",
    d: "M490.89,63.94c4.4-.2,2.62,5.73,2.96,9.58h-1.58v-5.98c0-1.53-.4-2.42-1.93-2.37-3.56.1-2.17,5.04-2.42,8.35h-1.58l-.05-9.38h1.48c.05.49-.05,1.19.1,1.58.54-1.09,1.43-1.73,3.01-1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-32",
    "data-name": "aj",
    className: "microsites-phase5-3",
    d: "M499.93,63.94c3.11,0,4.25,2.07,4.15,5.23h-6.67c0,1.98.69,3.31,2.62,3.36,1.28.05,2.12-.59,2.42-1.43l1.38.4c-.54,1.38-1.83,2.22-3.8,2.22-2.86,0-4.35-1.83-4.3-4.94.05-3.01,1.28-4.84,4.2-4.84ZM502.5,67.94c.3-2.96-3.75-3.8-4.79-1.38-.15.35-.3.84-.3,1.38h5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-11",
    "data-name": "af",
    className: "microsites-phase5-3",
    d: "M509.06,63.94c1.53,0,2.37.64,2.96,1.63l-.05-4.94h1.58l.05,12.89h-1.48c-.1-.49,0-1.14-.15-1.53-.49,1.14-1.38,1.73-2.91,1.73-2.62,0-3.41-1.93-3.46-4.84,0-3.26,1.14-4.94,3.46-4.94ZM509.51,65.12c-1.98,0-2.27,1.68-2.27,3.7s.3,3.65,2.22,3.65c2.07,0,2.52-1.58,2.52-3.75s-.44-3.65-2.47-3.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aF",
    className: "microsites-phase5-3",
    d: "M525.36,63.94c2.62,0,3.41,1.93,3.46,4.84,0,3.26-1.14,4.94-3.46,4.94-1.53-.05-2.42-.54-2.91-1.68l-.1,1.48h-1.53l.05-12.89h1.58v4.99c.49-1.14,1.38-1.68,2.91-1.68ZM524.96,72.53c1.98,0,2.22-1.68,2.22-3.7s-.25-3.7-2.22-3.65c-2.07,0-2.52,1.58-2.52,3.75s.49,3.6,2.52,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-4",
    "data-name": "aw",
    className: "microsites-phase5-3",
    d: "M538.4,64.14l-4.25,10.91c-.69,1.38-1.83,2.52-4,2.07v-1.19c1.93.3,2.62-.99,3.16-2.47l-3.7-9.33h1.68l2.81,7.7,2.67-7.7h1.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aG",
    className: "microsites-phase5-3",
    d: "M544.87,73.52v-12.25h1.63v10.91h6.17v1.33h-7.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-15",
    "data-name": "ah",
    className: "microsites-phase5-3",
    d: "M554.45,62.11v-1.48h1.58v1.48h-1.58ZM554.45,73.52v-9.38h1.58v9.38h-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-11",
    "data-name": "aq",
    className: "microsites-phase5-3",
    d: "M558.35,73.52v-12.89h1.58v12.89h-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-12",
    "data-name": "aq",
    className: "microsites-phase5-3",
    d: "M562.25,73.52v-12.89h1.58v12.89h-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-5",
    "data-name": "aw",
    className: "microsites-phase5-3",
    d: "M573.8,64.14l-4.25,10.91c-.69,1.38-1.83,2.52-4,2.07v-1.19c1.93.3,2.62-.99,3.16-2.47l-3.7-9.33h1.68l2.81,7.7,2.67-7.7h1.63"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-8",
    d: "M518.15,100.17v349c0,3.31-2.69,6-6,6h-208.34c-3.31,0-6,2.69-6,6v35.46"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-9",
    d: "M518.65,100.17h-1v-.5h1v.5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-10",
    d: "M297.81,511.4l-4.63-14.27h9.27l-4.64,14.27Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-8",
    d: "M172.6,414.84v34.33c0,3.31,2.69,6,6,6h113.2c3.31,0,6,2.69,6,6v35.46"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-9",
    d: "M173.1,414.85h-1v-.5h1v.5Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase5-10",
    d: "M297.81,511.4l-4.63-14.27h9.27l-4.64,14.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrositesPhase5);
export default __webpack_public_path__ + "static/media/Microsites-phase-5.b19fbc58b5ee209f6ac9e00c8df21809.svg";
export { ForwardRef as ReactComponent };